import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { useCurrency } from "../../context/CurrencyContext";
import { formatPriceSync } from "../../utils/currency";
import { getActivityImageUrl } from "../../lib/activityApi";

const BADGES = ["Super Saver", "Recommended", "New"];
const BADGE_CLASS = {
  "Super Saver": "bg-red-500 text-white",
  "Recommended": "bg-amber-400 text-gray-900",
  "New": "bg-cyan-500 text-white",
};

export default function ActivityCard({ activity, minPrice, badgeIndex = 0, onClick, baseUrl }) {
  const { currency } = useCurrency();
  const img = activity?.images?.[0];
  const imgUrl = getActivityImageUrl(img, baseUrl);
  const price = minPrice ?? 99;
  const oldPrice = Math.round(price * 1.36);
  const discountPct = oldPrice > 0 ? Math.round(((oldPrice - price) / oldPrice) * 100) : 0;
  const badge = BADGES[badgeIndex % BADGES.length];

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="group cursor-pointer rounded-xl overflow-hidden bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 w-full"
      onClick={onClick}
    >
      <div className="relative w-full h-[200px] overflow-hidden">
        <img
          src={imgUrl}
          alt={activity?.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <span className={`absolute top-3 left-3 px-2.5 py-1 rounded text-xs font-semibold shadow-sm ${BADGE_CLASS[badge] || "bg-gray-700 text-white"}`}>
          {badge}
        </span>
        <motion.button
          type="button"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-sm hover:bg-white"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.85 }}
          onClick={(e) => { e.stopPropagation(); }}
        >
          <FiHeart className="w-5 h-5 text-[#222222]" />
        </motion.button>
      </div>
      <div className="p-4">
        <h3 className="text-[14px] font-bold text-[#222222] line-clamp-2 leading-snug group-hover:opacity-90">
          {activity?.name}
        </h3>
        <div className="flex items-center gap-1.5 mt-2">
          <FaStar className="w-4 h-4 shrink-0" style={{ color: "#FFC107" }} />
          <span className="text-sm font-semibold text-[#222222]">4.9</span>
          <span className="text-xs text-gray-500">(175 Reviews)</span>
        </div>
        <div className="mt-3 flex flex-wrap items-end justify-between gap-2">
          <div className="flex flex-col">
            <span className="text-xs text-gray-500 uppercase">From</span>
            <span className="text-sm text-gray-500 line-through">{formatPriceSync(oldPrice, currency)}</span>
            <div className="flex items-baseline gap-2 flex-wrap">
              <span className="text-lg font-bold text-[#222222]">{formatPriceSync(price, currency)}</span>
              {discountPct > 0 && (
                <span className="text-xs font-semibold text-white px-1.5 py-0.5 rounded" style={{ backgroundColor: "#4CAF50" }}>
                  Save {discountPct}%
                </span>
              )}
            </div>
          </div>
          <span className="px-3 py-2 text-white font-semibold rounded-lg text-sm hover:opacity-90 inline-block" style={{ backgroundColor: "#1ABCE3" }}>
            Check Availability
          </span>
        </div>
      </div>
    </motion.div>
  );
}
